<a [FCRouterLink]="route" [id]="'fc-more-details-' + content.product.id" (click)="onMoreDetails()">More Details</a>